import { Button } from '../ui/button';
import { Plus, Minus } from 'lucide-react';

export default function AddonCounter({ label, value, onChange, price, min = 0 }) {
  return (
    <div className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
      <div>
        <p className="text-sm font-medium text-gray-800">{label}</p>
        <p className="text-xs text-gray-500">${price}/mo each</p>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          className="h-7 w-7 p-0"
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
          data-testid={`addon-${label.toLowerCase().replace(/\s/g, '-')}-minus`}
        >
          <Minus className="w-3 h-3" />
        </Button>
        <span className="w-8 text-center text-sm font-medium" data-testid={`addon-${label.toLowerCase().replace(/\s/g, '-')}-value`}>{value}</span>
        <Button
          variant="outline"
          size="sm"
          className="h-7 w-7 p-0"
          onClick={() => onChange(value + 1)}
          data-testid={`addon-${label.toLowerCase().replace(/\s/g, '-')}-plus`}
        >
          <Plus className="w-3 h-3" />
        </Button>
      </div>
    </div>
  );
}
